/* The city guides' weather-by-month table. Five short columns fit a phone, but
   it still scrolls sideways inside its own box rather than ever widening the
   page. */

.scroller {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table {
  width: 100%;
  max-width: 640px;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px 12px;
  text-align: left;
  vertical-align: top;
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

.table thead th {
  white-space: nowrap;
}

.number {
  text-align: right !important;
  white-space: nowrap;
}

/* Phones (Breakpoints.sm=640): tighter cells so all five columns fit. */
@media (max-width: 639px) {
  .table th,
  .table td {
    padding: 6px;
  }
}
